import nextTime from './next-time';

export { default as times, TIME_STEP } from './times';
export { default as today } from './today';
export { default as nextTime } from './next-time';

export const nextTimeInTimes = nextTime();
